import { EnvironmentService } from './EnvironmentService';

const environmentService = new EnvironmentService({
	VITE_BASE_API_URL: 'localhost',
	VITE_BASE_CACHE_EXPIRE_TIME_S: '3600',
	VITE_BASE_API_USERNAME: '',
	VITE_BASE_API_PASSWORD: ''
});

export { environmentService };
